/**
 * 功能: 报告里关联附件 可以关联专家说、表说、数说, 也可以新增一条数据
 */

<template lang="pug">
    el-dialog.attachment-dialog(title="关联附件" :visible.sync="isShow" width="80%" top="20px" :close-on-press-escape="false" :close-on-click-modal="false")
      el-row(style="margin-top: 5px;")
        el-input(placeholder="请输入搜索内容" v-model="pageQuery.fullSearch" style="width: 50%" :size="GLOBAL.SIZE_OF_INPUTBOX" clearable)
          el-button(slot="append" icon="el-icon-search" @click="getAttachmentPage")
      el-row(type="flex" justify="space-between" style="margin-top: 20px")
        el-col(:span="22")
          el-radio-group(
            v-model="currentView"
            :size="GLOBAL.SIZE_OF_INPUTBOX"
            @change="handleChange")
            el-radio-button(label="quote" v-if="currentView === 'quote'") 专家说
            el-radio-button(label="table" v-if="currentView === 'table'") 表说
            el-radio-button(label="size" v-if="currentView === 'size'") 数说
        el-col(:span="2")
          el-button(:size="GLOBAL.SIZE_OF_INPUTBOX" @click="handleShowAdd") 添加
      .attachment-box(style="margin-top: 20px; height: 580px; overflow: auto")
        Quote(v-if="currentView === 'quote'" :quoteData="attachmentData" v-bind="$attrs" v-on="$listeners")
        Table(v-if="currentView === 'table'" :tableData="attachmentData" v-bind="$attrs" v-on="$listeners")
        Size(v-if="currentView === 'size'" :sizeData="attachmentData" v-bind="$attrs" v-on="$listeners")
      el-pagination(
        @current-change="handleCurrentChange"
        :current-page.sync="pageQuery.currentPage"
        :page-size="pageQuery.pageSize"
        layout="total, prev, pager, next"
        :total="total")
      QuoteDialog(ref="quoteRef" @saveQuote="saveQuote" :quoteInfo="quoteInfo" :isChildDialog="true" @close="handleClose")
      TableDialog(ref="tableRef" @addTable="addTable" :newTable="newTable" :isChildDialog="true" @close="handleClose")
      SizeDialog(ref="sizeRef" @saveSize="saveSize" :size="newSize" :isChildDialog="true" @close="handleClose")
</template>

<script>
import Quote from '../../contents/attachment/quote'
import Table from '../../contents/attachment/table'
import Size from '../../contents/attachment/size'
import api from '@/apis/attachment'

import QuoteDialog from '@/views/quote/components/quoteDialog'
import TableDialog from '@/views/table/components/tableForm'
import SizeDialog from '@/views/size/components/sizeForm'

export default {
  name: 'AttrDialog',
  components: { Quote, Table, Size, QuoteDialog, TableDialog, SizeDialog },
  props: {
    brief: Object
  },
  data () {
    return {
      isShow: false,
      currentView: '',
      pageQuery: {
        fullSearch: '',
        currentPage: 1,
        pageSize: 10,
        sortwhere: { }
      },
      attachmentData: [],
      total: 1,
      quoteInfo: {
        status: 0,
        industryId: [],
        industry: []
      },
      newTable: {
        isPolicy: true,
        industryId: [],
        industry: [],
        status: 0
      },
      newSize: {
        title: '',
        description: '',
        authority: '',
        status: 0,
        source: '',
        sourceUrl: '',
        industry: [],
        industryId: [],
        kind: 0,
        barType: 0,
        products: [],
        brandName: '',
        XunitName: ''
      }
    }
  },
  methods: {
    // 显示列表弹框
    show (_class) {
      if (_class === 1) {
        this.currentView = 'table'
      } else if (_class === 2) {
        this.currentView = 'size'
      } else {
        this.currentView = 'quote'
      }
      this.isShow = true
      this.getAttachmentPage()
    },
    close () {
      this.isShow = false
    },
    /* 分发附件数据 */
    getAttachmentPage () {
      if (this.currentView === 'quote') {
        api.getQuotePage(this.pageQuery).then(res => {
          this.handleResult(res, '', () => {
            this.attachmentData = res.data.data
            this.total = res.data.count
          })
        }).catch(err => {
          this.$message({ message: '获取失败!' + err, type: 'error', duration: 2000 })
        })
      } else if (this.currentView === 'table') {
        api.getTable(this.pageQuery).then(res => {
          this.handleResult(res, '', () => {
            this.attachmentData = res.data.data
            this.total = res.data.count
          })
        }).catch(err => {
          this.$message({ message: '获取失败!' + err, type: 'error', duration: 2000 })
        })
      } else if (this.currentView === 'size') {
        // this.pageQuery.statusAttch = 1
        api.getSizePage(this.pageQuery).then(res => {
          this.handleResult(res, '', () => {
            this.attachmentData = res.data.data
            this.total = res.data.count
          })
        }).catch(err => {
          this.$message({ message: '获取失败!' + err, type: 'error', duration: 2000 })
        })
      }
    },
    // 显示添加附件的弹框
    handleShowAdd () { // 显示添加模态框
      if (this.currentView === 'quote') {
        this.$refs.quoteRef.isShowQuoteDialog()
        this.quoteInfo = {
          industryId: this.brief.industryId || [],
          industry: this.brief.industry || [],
          status: 0,
          brandName: this.brief.brandName
        }
      } else if (this.currentView === 'table') {
        this.$refs.tableRef.show()
        this.newTable = {
          isPolicy: true,
          industryId: this.brief.industryId || [],
          industry: this.brief.industry || [],
          status: 0,
          source: this.brief.brandName
        }
      } else if (this.currentView === 'size') {
        // const details = this.$router.resolve({ name: 'sizeProFrom' })
        // window.open(details.href, '_blank')
        this.$refs.sizeRef.show()
      }
    },
    // 附件弹框列表数据切换
    handleCurrentChange (val) {
      this.pageQuery.currentPage = val
      this.getAttachmentPage()
    },
    /* tab跳转需要重置页码 */
    handleChange () {
      this.pageQuery.currentPage = 1
      this.getAttachmentPage()
    },
    // 新增一条专家说
    saveQuote (quote, cb) {
      api.addNewQuote(quote).then(res => {
        this.handleResult(res, '添加专家说', () => {
          this.quoteInfo = { status: 0 }
          this.getAttachmentPage()
          cb && cb()
        })
      })
    },
    // 新增表说
    addTable (table, cb) {
      api.addTable(table).then(res => {
        this.handleResult(res, '添加表说', () => {
          this.newTable = {
            isPolicy: true,
            industryId: [],
            industry: [],
            status: 0
          }
          this.getAttachmentPage()
          cb && cb()
        })
      })
    },
    saveSize (size, cb) {
      if (!size.id) {
        api
          .saveSize(size)
          .then(r => {
            this.$message({
              message: '新建成功',
              type: 'success'
            })
          })
          .catch(err => {
            this.$message({
              message: err,
              type: 'error'
            })
          }).finally(() => {
            console.log('==========')
            this.getAttachmentPage()
            cb && cb()
          })
      } else {
        api
          .updateSize(size)
          .then(r => {
            this.$message({
              message: '更新成功',
              type: 'success'
            })
          })
          .catch(err => {
            this.$message({
              message: err,
              type: 'error'
            })
          }).finally(() => {
            this.getAttachmentPage()
            cb && cb()
          })
      }
    },
    handleClose () { }

  }
}
</script>

<style lang="scss">
.attachment-dialog {
  .el-dialog {
    height: 800px;
  }
  .el-dialog__header {
    padding: 15px 20px 5px;
  }
  .el-dialog__body {
    overflow: hidden;
    padding: 5px 20px 10px;
  }
}
</style>
